// TODO - remove lint disable when editing this file
/* eslint-disable */
/*
  This module forwards $rootScope broadcast messages into redux
*/
import { createAction } from 'redux-actions'
import { routeChangingAction, routeChangedAction } from '~/redux/routeReducer'

// A common prefix for forwarded actions
export const ACTION_ANGULAR_PREFIX = 'ellipsis.angular.'

// Convenient function to build action name from Angular broadcasted event
export const angularActionNameBuilder = (name) =>
  `${ACTION_ANGULAR_PREFIX}${name.toLowerCase()}`

// Convenient function to build action name from Angular broadcasted DISPATCH event
export const angularDispatchedActionNameBuilder = (name) =>
  `${ACTION_ANGULAR_PREFIX}dispatch.${name.toLowerCase()}`

// Redispatch rootScope DISPATCH through redux
const createDispatcherForDispatch = (store) => (event, action) => {
  const reduxAction = createAction(
    angularDispatchedActionNameBuilder(action.type || action.event.type)
  )
  store.dispatch(reduxAction(action))
}

// Redispatch any other rootScope stuff
const createLegacyDispatcher = (store) => (legacyActionName) => {
  const reduxAction = createAction(angularActionNameBuilder(legacyActionName))
  return (event, action) => store.dispatch(reduxAction(action))
}

export default function wireup($ngRedux, $rootScope) {
  // Hook on $rootScope for DISPATCH
  $rootScope.$on('DISPATCH', createDispatcherForDispatch($ngRedux))
  // Hook on $rootScope for some other events
  const redispatchFor = createLegacyDispatcher($ngRedux)
  const scopeActions = [
    'BEFORE_SAVE',
    'CHANGE_TAB',
    'RIGHT_TAB_CHANGE',
    'SETTINGS_LOADED',
    'ELEMENT_FOCUS_CHANGE',
    'SAVE_SUCCESS',
    'LOCK_STORY_INACTIVE_TIMEOUT',
  ]
  scopeActions.forEach((name) => $rootScope.$on(name, redispatchFor(name)))

  hackyWireupRevisions($rootScope)
  wireupRouter($rootScope, $ngRedux)
}

export function wireupRouter($rootScope, $ngRedux) {
  $rootScope.$on(
    '$routeChangeStart',
    (e, { params, $$route }, { $$route: routeFrom = {} } = {}) => {
      if (!$$route) return
      $ngRedux.dispatch(
        routeChangingAction({
          params,
          current: $$route.originalPath,
          from: routeFrom.originalPath,
        })
      )
    }
  )
  $rootScope.$on('$routeChangeSuccess', () => {
    $ngRedux.dispatch(routeChangedAction())
  })
}

// This method should be removed after implementing revisions in react
// Watch for `navigateToRevision` route configuration and emit RIGHT_TAB_CHANGE event
export function hackyWireupRevisions($rootScope) {
  $rootScope.$on('$routeChangeSuccess', (_, { $$route }) => {
    if ($$route.navigateToRevision === true) {
      setTimeout(() => {
        $rootScope.$broadcast('RIGHT_TAB_CHANGE', {
          vertActive: 'revisions',
        })
      })
    }
  })
}
